/**
 * HARPIA Performance — "Search by Car & Model" finder.
 *
 * Progressively enhances every `[data-vehicle-finder]` form on the page
 * (there can be more than one — e.g. the header popover and the homepage
 * section both use the same markup). Populates the make/model selects from
 * `window.HARPIA_VEHICLES` (see vehicle-data.js) and, on submit, rewrites
 * the hidden query field into a Shopify search query that matches the
 * `fit_<make>-<model>` tag convention.
 */
(function () {
  function slugify(value) {
    return String(value)
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initFinder(form) {
    var makeSelect = form.querySelector('[data-vehicle-finder-make]');
    var modelSelect = form.querySelector('[data-vehicle-finder-model]');
    var queryInput = form.querySelector('[data-vehicle-finder-query]');
    var submitButton = form.querySelector('[data-vehicle-finder-submit]');
    var vehicles = window.HARPIA_VEHICLES || {};

    if (!makeSelect || !modelSelect || !queryInput) return;

    Object.keys(vehicles)
      .sort(function (a, b) { return a.localeCompare(b); })
      .forEach(function (make) {
        var option = document.createElement('option');
        option.value = make;
        option.textContent = make;
        makeSelect.appendChild(option);
      });

    function resetModels(placeholderText) {
      modelSelect.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = placeholderText;
      modelSelect.appendChild(placeholder);
    }

    makeSelect.addEventListener('change', function () {
      var models = vehicles[makeSelect.value] || [];

      if (!makeSelect.value) {
        resetModels(modelSelect.dataset.placeholder || 'Select make first');
        modelSelect.disabled = true;
      } else {
        resetModels(modelSelect.dataset.placeholderReady || 'Select model');
        models.forEach(function (model) {
          var option = document.createElement('option');
          option.value = model;
          option.textContent = model;
          modelSelect.appendChild(option);
        });
        modelSelect.disabled = false;
      }

      modelSelect.value = '';
      updateSubmitState();
    });

    modelSelect.addEventListener('change', updateSubmitState);

    function updateSubmitState() {
      if (!submitButton) return;
      submitButton.disabled = !(makeSelect.value && modelSelect.value);
    }

    form.addEventListener('submit', function (event) {
      if (!makeSelect.value || !modelSelect.value) {
        event.preventDefault();
        return;
      }

      var tag = 'fit_' + slugify(makeSelect.value) + '-' + slugify(modelSelect.value);
      queryInput.value = 'tag:' + tag;
    });

    updateSubmitState();
  }

  function init() {
    document.querySelectorAll('[data-vehicle-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
